var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.0005 39.9996C63.3671 39.9996 48.5171 44.6663 38.7338 53.9663C38.3005 53.3996 37.9338 52.8996 37.7005 52.5329C36.2171 50.1829 34.5005 47.4329 33.2505 44.6496C33.0171 44.1329 32.8171 43.6496 32.6505 43.1996C33.7338 43.4663 35.0171 43.6496 36.4171 43.5663C37.7505 43.4829 39.1671 43.0329 40.4505 42.0663C41.6671 41.1496 42.3838 40.0496 42.7838 39.1829C43.5338 37.5829 43.6005 35.9996 43.6005 35.0329C43.6005 32.9329 43.0838 30.4663 42.5005 28.2329C41.3005 23.5996 38.9338 6.86628 37.4838 3.34961L26.9171 19.6496C28.1005 22.5329 29.6338 26.6496 30.6838 30.2996C30.4338 30.2496 30.1838 30.1996 29.9171 30.1829C28.9338 30.0663 27.4838 30.0329 25.8671 30.6163C21.9338 32.0329 20.6505 35.5163 20.2505 37.6829C19.4338 42.1329 20.9671 46.6163 22.4505 49.9163C24.0005 53.3663 25.5671 54.6996 25.5671 54.6996L29.8505 59.6496L32.4338 61.9496C30.3838 65.3496 28.8005 69.1329 27.8505 73.3329C25.6671 72.2163 23.1005 70.8996 20.8671 69.4329C20.4505 69.1663 20.0671 68.8996 19.7171 68.6329C20.6005 68.4663 21.6005 68.1829 22.5171 67.6663C23.4005 67.1829 24.1671 66.4163 24.5838 65.3496C24.9838 64.3329 24.9338 63.3663 24.7838 62.6329C24.5171 61.2996 23.7838 60.1996 23.3005 59.5496C22.2505 58.1329 20.6838 56.6163 19.1838 55.2996C16.0671 52.5496 6.13379 41.9496 3.38379 40.0329L4.08379 54.4996C6.33379 56.0829 9.43379 58.3663 11.9671 60.5163C11.7671 60.5663 11.5671 60.6163 11.3671 60.6829C10.6171 60.9163 9.60046 61.3663 8.76712 62.2829C6.73379 64.5163 7.56712 67.2996 8.35046 68.8829C9.98379 72.1663 13.2671 74.7163 15.9338 76.4663C18.7171 78.2996 20.4671 78.6996 20.4671 78.6996L25.9005 80.6663L26.8671 80.8996C26.8171 81.8663 26.7171 82.8163 26.7171 83.8329C26.7171 113.05 50.6005 143.35 80.0505 143.35C109.5 143.35 133.384 113.05 133.384 83.8329C133.384 54.6163 109.5 40.0163 80.0505 40.0163L80.0005 39.9996Z",
    fill: "url(#paint0_linear_1617_47579)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M42.9333 118.334C36.25 108.851 32.25 97.284 32.25 85.9007C32.25 59.5007 53.75 46.3173 80.2667 46.3173C96.7833 46.3173 111.367 51.434 120 61.684C111.8 49.4506 96.0667 43.334 78.0167 43.334C51.5 43.334 30 56.5173 30 82.9173C30 95.534 34.9167 108.367 42.9333 118.334Z",
    fill: "#E8EAEA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1617_47579",
    x1: 121.517,
    y1: 129.1,
    x2: 18.9005,
    y2: 26.4829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11181B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1E282D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#343E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#8E9496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EAEA",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadBase);
export default __webpack_public_path__ + "static/media/head-base.fb1d067dcd63d02e1b9307414bec59a9.svg";
export { ForwardRef as ReactComponent };